// extracted by mini-css-extract-plugin
module.exports = {"Container":"_31sHFcw9miDkzzDidw1evF","SubHeading":"_1xeNxmsj2rw72-Udl09-tE","RoleItem":"_3RAm5BxHAnFzv16XQlFAfB","RoleItemDark":"_1sSbhOKCXs1qxadspHKb_9"};